import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {
  AminoAcidColoring,
  getAminoAcidBackgroundColor,
  getAminoAcidGlyphColor,
  ProteinColorScheme,
} from 'molbio/aa-sequences/util/AaSequenceColoringConstants';
import {BasicAminoAcidSLA} from 'molbio/aa-sequences/util/AaSequenceConstants';

const EXAMPLE_CODONS: Array<BasicAminoAcidSLA> = ['A', 'C', 'D', 'F'];

/**
 * Tiny component for easily accessing individual glyphs for testing
 * @package
 */
export function Codon({coloring, glyph}: {coloring: AminoAcidColoring | null; glyph: string}): JSX.Element {
  return (
    <div
      style={{
        backgroundColor: coloring?.backgroundColor ?? 'transparent',
        color: coloring?.glyphColor ?? 'inherit',
      }}
      className={css(styles.codon)}
    >
      {glyph}
    </div>
  );
}

function StandardColorSchemePreview({colorScheme}: {colorScheme: ProteinColorScheme}): JSX.Element {
  return (
    <div className={css(styles.flex)}>
      {EXAMPLE_CODONS.map((codon: BasicAminoAcidSLA, index: number) => (
        <Codon
          key={codon}
          coloring={{
            backgroundColor: getAminoAcidBackgroundColor(codon, index, colorScheme),
            glyphColor: getAminoAcidGlyphColor(codon, colorScheme),
          }}
          glyph={codon}
        />
      ))}
    </div>
  );
}

export interface AaSequenceColoringOptionContentProps {
  colorScheme: ProteinColorScheme;
}

export default function AaSequenceColoringOptionContent({
  colorScheme,
}: AaSequenceColoringOptionContentProps): JSX.Element {
  return (
    <div className={css(styles.flex, styles.wrapper)}>
      {/* ProteinColorScheme uses display strings for values instead of values being identical to the keys */}
      <span>{colorScheme}</span>
      <StandardColorSchemePreview colorScheme={colorScheme} />
    </div>
  );
}

const styles = StyleSheet.create({
  flex: {
    display: 'flex',
  },
  wrapper: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  codon: {
    width: '1em',
    height: '1em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
  },
});
